import moment from 'moment';

/**
 * 时间戳过滤
 * @param {*} time
 */
export const fTime = (time) => {
  return moment(time).format("YYYY-MM-DD");
};

/**
 * 金额保留位
 */
export const fmoney = (money) => {
  if (parseFloat(money) >= 0 && money != null) {
    let fmtAmt = parseFloat(money).toFixed(2);
    let fmtAmt1 = parseInt(fmtAmt.split(".")[0]).toLocaleString();
    let fmtAmt2 = fmtAmt.split(".")[1];
    let fmtAmt3 = fmtAmt1 + "." + fmtAmt2;
    return fmtAmt3;
  } else {
    let fmtAmt = (parseFloat(money) * (-1)).toFixed(2);
    let fmtAmt1 = parseInt(fmtAmt.split(".")[0]).toLocaleString();
    let fmtAmt2 = fmtAmt.split(".")[1];
    let fmtAmt3 = "-" + fmtAmt1 + "." + fmtAmt2;
    return fmtAmt3;
  }
};
export function isNullOrEmpty(val) {
  if (typeof val == 'boolean') {
      return false;
  }
  if (typeof val == 'number') {
      return false;
  }
  if (val instanceof Array) {
      if (val.length == 0) return true;
  } else if (val instanceof Object) {
      if (JSON.stringify(val) === '{}') return true;
  } else {
      if (val == 'null' || val == null || val == 'undefined' || val == undefined || val == '') return true;
      return false;
  }
  return false;
}